import { HomePastePage } from './HomePastePage';
export default HomePastePage;
